// Booking + editable constants for ReplAIced.work

export const CALENDAR_BOOKING_URL = "https://calendar.app.google/jTubjqLvJbUTt2MQ9";

// official Google Calendar appointment embed URL (the gv=true variant).
export const CALENDAR_EMBED_URL =
    "https://calendar.google.com/calendar/appointments/schedules/AcZssZ2b1zsSw4nL0hkDI1pxo7fBajx5zOVOHmkI05KVQnp8Cq7sQnvP2WNxio0MMp55L1A0Gei1Q9Qd?gv=true";

// blended hourly rate used by the cost calculator (editable constant)
export const BLENDED_HOURLY_RATE = 35;

// "Run" tier starting price, shared by Pricing and the calculator so they can never disagree.
export const RUN_RETAINER_FROM = 3000; // CAD
export const CALC_HIGH_THRESHOLD = 3 * RUN_RETAINER_FROM; // cost at/above this => "fraction of this"
export const CALC_MID_THRESHOLD = 1.2 * RUN_RETAINER_FROM; // cost above this => "less than this grind"

// shared top offset for pinned section headers (nav is 64px, ~40px clear space below it)
export const PINNED_HEADER_TOP = "top-[104px]";

export const NAV_LINKS = [
    { label: "The weight", href: "#weight" },
    { label: "How it works", href: "#how-it-works" },
    { label: "The math", href: "#math" },
    { label: "Proof", href: "#proof" },
    { label: "Pricing", href: "#pricing" },
];
